module.exports = __webpack_public_path__ + "static/media/browser.5ef5f772.cjs";